import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import HorizontalScroll from 'components/dashboard/forms/button/mock/HorizontalScroll';
import event1 from "../../../../assets/images/event1.png"
import event2 from "../../../../assets/images/event2.png"
import event3 from "../../../../assets/images/event3.png"
import { MockTestCard } from 'components/dashboard/forms/button/mock/MockTestCard';

const MockTest = () => {
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
  const navigate = useNavigate()
  // eslint-disable-next-line no-unused-vars
  const [endpoint, setApiEndpoint] = useState('')
  const [bgColor, setBgColor] = useState("")
  const [rateBg, setRateBg] = useState("")
  const [textColor, setTextColor] = useState("")


  useEffect(() => {
   
    if (roles) {
        if (roles === 'student') {
           setBgColor("bg-primary")
           setTextColor('text-[#00296B]')
           setRateBg('bg-primary')
            setApiEndpoint('/student-dashboard-endpoint');
        } else if (roles === 'teacher') {
          setBgColor("bg-blueColor")
          setTextColor('text-primary')
          setRateBg('bg-blueColor')
            setApiEndpoint('/teacher-dashboard-endpoint');
        } else {
            navigate('/guest-dashboard-endpoint'); 
        }
    }
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [navigate]);
  const testMocks = [
    {
      id:1,
      img:event1,
      name:"Nigeria's 64th Independence Day",
      time:"4.00pm",
      date:" 24.04.2024"
    },
    {
      id:2,
      img:event2,
      name:"Junior West Africa Entrance Examination",
      time:"4.00pm",
      date:" 24.04.2024"
    },
    {
      id:3,
      img:event3,
      name:"Annual Lagos Teacher's Day Celebration",
      time:"4.00pm",
      date:" 24.04.2024"
    },
    {
      id:4,
      img:event3,
      name:"Annual Lagos Teacher's Day Celebration",
      time:"4.00pm",
      date:" 24.04.2024"
    },
   ]

   const mocks = [
    {
      id: 1,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Science",
      text: "Advanced Chemistry- Introduction to Chemistry For SS3 Students",
      instructorName: "Adebayo olawuyi",
      activityText: "Introduction to Chemistry",
      instructorRole: "Instructor",
      courseDescription:
        "The impact of these pre-colonial political arrangements on federalism in Nigeria is profound. As the country transitioned to colonial rule, British colonial administrators recognized the diversity of indigenous political systems and sought to govern Nigeria through a system of indirect rule. This approach preserved traditional authorities and structures of governance at the local level while establishing a centralized colonial administration.",
      status: "completed test",
      rate: 70,
    },
    {
      id: 2,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Arts & Humanities",
      text: "Government: The Pre-Colonial Era in Nigeria",
      activityText: "Government: The Pre-Colonial Era",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      courseDescription:
        "The impact of these pre-colonial political arrangements on federalism in Nigeria is profound. As the country transitioned to colonial rule, British colonial administrators recognized the diversity of indigenous political systems and sought to govern Nigeria through a system of indirect rule. This approach preserved traditional authorities and structures of governance at the local level while establishing a centralized colonial administration.",
      status: "completed test",
      courseOutcome: [
        {
          id: "1",
          outcome: "Understanding the diverse indigenous political structures",
        },
        {
          id: "2",
          outcome: "Colonial legacies contribute to contemporary challenges.",
        },
        {
          id: "3",
          outcome: "The groundwork for Nigeria's federal system.",
        },
        {
          id: "4",
          outcome: "Opportunities for unity, equity, and prosperity",
        },
      ],
      audience:"Pretium at parturient curabitur eget nunc pharetra. Vitae pharetra adipiscing purus faucibus bibendum. Ultrices mi tristique et enim pretium lacus, vivamus. Augue eget fermentum, mauris viverra. Tristique arcu ipsum risus a arcu pellentesque pharetra velit.",
      rate: 70,
    },
    {
      id: 3,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      rate: 70,
      status: "completed test",
    },
    {
      id: 4,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      status: "completed test",
      rate: 50,
    },
    {
      id: 5,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      status: "completed test",
      rate: 70,
    },
    {
      id: 6,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      rate: 40,
      status: "continued test",
    },
    {
      id: 7,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      status: "continued test",
      rate: 70,
    },
    {
      id: 8,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      rate: 70,
      status: "cancelled test",
    },
    {
      id: 9,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      rate: 70,
      status: "completed test",
    },
    {
      id: 10,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      status: "continued test",
      rate: 70,
    },
    {
      id: 11,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      profileImg:
        "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      rate: 70,
      status: "completed test",
    },
  ];
   const statuses = ["all", "continued test", "completed test", "cancelled test"];
   const [mockStatus, setMockStatus] = useState("all");
   const filteredData = mockStatus === "all" ? mocks : mocks.filter((item) => item.status === mockStatus);
     // Function to calculate the number of items for each status
     const getStatusCount = (status) => {
      if (status === "all") return "";
      const count = mocks.filter((item) => item.status === status).length;
      return count > 0 ? `(${count})` : "";
  };
  

  const handleViewClick = (id) => {
    const selectedMock = mocks.find((mock) => mock.id === id);
    navigate("../mock-test/mock-details", {
      state: { mockData: selectedMock }, // Pass the entire row data as state
    });
    localStorage.setItem("#mockRow", JSON.stringify(selectedMock.id));
    console.log("View course Detail", selectedMock.id);
  };

  return (
    <div className='p-6 bg-gray-100 flex flex-col gap-6 overflow-auto'>
         <HorizontalScroll data={testMocks} />
         <div className="flex gap-6 py-4 font-semibold items-center text-sm">
        {statuses.map((status) => (
          <button
          className={`px-8 py-2 text-[16px] font-ManropeSemibold leading-[24px] capitalize font-medium ${
            status === mockStatus ? `transition-all duration-100 ${bgColor} ${textColor}` : "bg-gray-200 text-neutral"
          }`}
            key={status}
            onClick={() => setMockStatus(status)}
          >
            {status} {getStatusCount(status)}
          </button>
        ))}
      </div>
      <div className="grid gap-6 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 ">
        {filteredData.map((mock) => (
          <MockTestCard
            key={mock.id}
            {...mock}
            rateBg={rateBg}
            handleViewClick={handleViewClick}
          />
        ))}
      </div>
    </div>
  );
};

export default MockTest;
